import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import AddPurchaseModal from "../../Components/AddPurchaseModal";
import distributorServices from "../../Services/distributorServices";
import salesService from "../../Services/salesService";
import moment from "moment/moment";
import AutoComplete from "react-select";
import {
  MdReceiptLong,
  MdCalendarToday,
  MdDelete,
  MdArrowForward,
  MdPerson,
  MdPhone,
  MdLocalPharmacy,
} from "react-icons/md";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import InvoiceSaleModal from "../../Components/InvoiceSaleModal";

const RecordSalesReturn = () => {
  const [sales, setSales] = useState([]);
  const [medicines, setMedicines] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [open, setOpen] = useState(false);
const [purchase, setPurchase] = useState({
  customer_name: "",
  customer_age: "",
  customer_phone: "",
  return_amount: 0,
  return_date: moment().format("YYYY-MM-DD"), 
  note: "",
});
  const [products, setProducts] = useState([]);
  const [medicinesOptions, setMedicinesOptions] = useState([]);
  const [salesOptions, setSalesOptions] = useState([]);
  const [selectedSale, setSelectedSale] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const medicineRef = useRef();
  const saleRef = useRef();

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString("en-US", options);
  };

  const handleSelectSale = async (selectedOption) => {
    const saleId = selectedOption.value;
    setSelectedSale(saleId);
    try {
      const response = await salesService.fetchSingle(saleId);
      const details = response.sale.details || [];
      setMedicines(details);
      setMedicinesOptions(
        details.map((item) => ({
          value: item.id,
          label: `${item.medicine_name} (PKR ${item.sale_price} - Batch: ${item.batch_no})`,
        }))
      );
    } catch {
      toast.error("Error fetching sale details");
    }
  };

  const handleSelectMedicine = (detailId) => {
    const medicine = medicines.find((m) => m.id === detailId);
    if (!medicine) { toast.error("Medicine not found."); return; }
    if (!selectedSale) { toast.error("Please select a sale first."); return; }
    const newProduct = {
      sale_id: selectedSale,
      medicine_id: medicine.id,
      itemCode: medicine.item_code,
      itemName: medicine.medicine_name,
      expiry_date: medicine.expiry_date,
      batch_no: medicine.batch_no,
      quantity: medicine.quantity,
      original_quantity: medicine.quantity,
      pack: medicine.pack_quantity || 1,
      box: medicine.box_quantity || 1,
      unit_price: parseFloat(medicine.unit_price) || 0,
      discount: parseFloat(medicine.discount) || 0,
      sale_price: parseFloat(medicine.sale_price),
      discount_price: parseFloat(medicine.discount_price),
      total_price: parseFloat(medicine.total_price),
    };
    setProducts([...products, newProduct]);
  };

  const handleRemovePurchase = (index) => {
    setProducts(products.filter((_, i) => i !== index));
  };

  // const handleQuantity = (index, name, value) => {
  //   setProducts((prev) => {
  //     const array = [...prev];
  //     let q = array[index].quantity;
  //     let p = array[index].sale_price;
  //     let dp = array[index].discount;
  //     if (name === "quantity") {
  //       value = parseFloat(value); // ✅ FIX
  //       if (value <= 0 || isNaN(value)) {
  //         toast.error("Quantity must be greater than zero");
  //         return prev;
  //       }
  //       q = value;
  //     } else if (name === "sale_price") {
  //       p = value;
  //     } else if (name === "discount") {
  //       dp = value;
  //     }
  //     array[index] = {
  //       ...array[index],
  //       [name]: value,
  //       discount_price: q * (p - dp),
  //       total_price: p * q,
  //     };
  //     return array;
  //   });
  // };

const handleQuantity = (index, name, value) => {
  setProducts((prev) => {
    const array = [...prev];
    let q = array[index].quantity;
    let p = array[index].sale_price;
    let dp = array[index].discount;

    if (name === "quantity") {
      value = parseFloat(value);

      if (value <= 0 || isNaN(value)) {
        toast.error("Quantity must be greater than zero");
        return prev;
      }

      // Prevent increasing quantity
      if (value > array[index].original_quantity) {
        toast.error(
          `You can return a maximum of ${array[index].original_quantity} items`
        );
        return prev;
      }

      q = value;
    } else if (name === "sale_price") {
      p = value;
    } else if (name === "discount") {
      dp = value;
    }

    array[index] = {
      ...array[index],
      [name]: value,
      discount_price: q * (p - dp),
      total_price: p * q,
    };

    return array;
  });
};

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!purchase.customer_name) { toast.error("Customer Name is required"); return; }
    if (!purchase.return_date) { toast.error("Invoice Date is required"); return; }
    if (products.length === 0) { toast.error("At least one medicine must be added"); return; }
    const missingExpiry = products.findIndex((p) => !p.expiry_date);
    if (missingExpiry !== -1) {
      toast.error(`Expiry date is required for item #${missingExpiry + 1} (${products[missingExpiry].itemName})`);
      return;
    }

    let totalAmount = products.reduce((sum, p) => sum + p.discount_price, 0);
    const submit = { ...purchase, return_amount: totalAmount, products };
    setLoading(true);
    salesService
      .createReturn(submit)
      .then(() => {
        navigate("/salesreturn");
        toast.success("Sale Return Created Successfully");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    const getSales = async () => {
      try {
        const response = await salesService.fetchAll();
        setSales(response.sales);
      } catch {
        toast.error("Error fetching Sales");
      }
    };
    getSales();
    medicineRef.current?.focus();
    saleRef.current?.focus();
  }, []);

  useEffect(() => {
    if (sales.length > 0) {
      setSalesOptions(
        sales.map((sale) => ({
          value: sale.id,
          label: `${sale.customer_name} (PKR ${sale.amount} - ${formatDate(sale.date)})`,
        }))
      );
    }
  }, [sales]);

  const totalAmount = products.reduce((sum, p) => sum + Number(p.total_price || 0), 0);
  const totalDiscount = products.reduce((sum, p) => sum + (p.discount * p.quantity || 0), 0);
  const totalDiscounted = products.reduce((sum, p) => sum + Number(p.discount_price || 0), 0);

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      borderRadius: "0.75rem",
    borderColor: state.isFocused ? "#00A95B" : "#d1d5db", 
      boxShadow: state.isFocused ? "0 0 0 4px rgba(59,130,246,0.1)" : "none",
      padding: "2px 4px",
      fontSize: "14px",
      fontFamily: "'DM Sans', sans-serif",
      background: "#f8fafc",
      "&:hover": { borderColor: "#00A95B" },
    }),
    option: (base, state) => ({
      ...base,
      fontSize: "13px",
      backgroundColor: state.isSelected ? "#00A95B" : state.isFocused ? "#eff6ff" : "white",
      color: state.isSelected ? "white" : "#0a2540",
    }),
    placeholder: (base) => ({ ...base, color: "#b0bcc9" }),
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap');
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .fade-up { animation: fadeUp 0.5s ease both; }
        .pos-input {
          background: #f8fafc;
          border: 1.5px solid #dde4ed;
          border-radius: 0.75rem;
          padding: 10px 14px;
          font-size: 14px;
          font-family: 'DM Sans', sans-serif;
          color: #0a2540;
          outline: none;
          transition: border-color 0.2s, box-shadow 0.2s;
          width: 100%;
        }
        .pos-input:focus {
          border-color: #00A95B;
          box-shadow: 0 0 0 4px rgba(59,130,246,0.1);
        }
        .pos-input::placeholder { color: #b0bcc9; }
        .cell-input {
          background: #f8fafc;
          border: 1.5px solid #dde4ed;
          border-radius: 0.5rem;
          padding: 5px 8px;
          font-size: 12px;
          font-family: 'DM Sans', sans-serif;
          color: #0a2540;
          outline: none;
          width: 72px;
          transition: border-color 0.2s;
        }
        .cell-input:focus { border-color: #00A95B; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
      `}</style>

      <div
        className="min-h-screen bg-[#f4f7fb] py-8 px-4 fade-up"
        style={{ fontFamily: "'DM Sans', sans-serif" }}
      >
        <div className="max-w-[1400px] mx-auto">

          {/* ── Page Header ── */}
          <div className="mb-8">
            <div className="flex items-center gap-3 mb-1">
              <div
                className="w-9 h-9 rounded-xl flex items-center justify-center"
               style={{ background: '#00A95B' }}
              >
                <MdReceiptLong size={18} className="text-white" />
              </div>
              <h1
                className="text-[#0a2540] text-[26px]"
                style={{ fontFamily: "'DM Serif Display', serif" }}
              >
                Sales Return
              </h1>
            </div>
            <p className="text-[#8a9bb0] text-sm ml-12">
              Select an original sale, choose medicines to return, and generate a return record.
            </p>
          </div>

          {/* ── Customer Info Card ── */}
          <div className="bg-white rounded-2xl shadow-sm border border-[#eef1f6] p-6 mb-6">
            <h2 className="text-[13px] font-semibold uppercase tracking-[0.8px] text-[#4a6080] mb-4">
              Customer &amp; Return Information
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

              {/* Customer Name */}
              <div>
                <label className="block text-[11px] font-semibold tracking-[0.7px] uppercase text-[#4a6080] mb-1.5">
                  Customer Name
                </label>
                <div className="relative flex items-center">
                  
                  <input
                    type="text"
                    className="pos-input pl-9"
                    placeholder="Enter customer name..."
                    onChange={(e) =>
                      setPurchase((p) => ({ ...p, customer_name: e.target.value }))
                    }
                  />
                </div>
              </div>

              {/* Return / Invoice Date */}
              <div>
                <label className="block text-[11px] font-semibold tracking-[0.7px] uppercase text-[#4a6080] mb-1.5">
                  Return Date
                </label>
                <div className="relative flex items-center">
                  
                 <input
                  type="date"
                  className="pos-input pl-9"
                  value={purchase.return_date}  
                  onChange={(e) =>
                    setPurchase((p) => ({
                      ...p,
                      return_date: moment(e.target.value).format("YYYY-MM-DD"),
                    }))
                  }
                />
                </div>
              </div>
            </div>
          </div>

          {/* ── Sale & Medicine Search Card ── */}
          <div className="bg-white rounded-2xl shadow-sm border border-[#eef1f6] p-6 mb-6">
            <h2 className="text-[13px] font-semibold uppercase tracking-[0.8px] text-[#4a6080] mb-4">
              Select Sale &amp; Medicines
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

              {/* Select Sale */}
              <div>
                <label className="block text-[11px] font-semibold tracking-[0.7px] uppercase text-[#4a6080] mb-1.5">
                  Original Sale
                </label>
                <AutoComplete
                  ref={saleRef}
                  styles={selectStyles}
                  options={salesOptions}
                  onChange={handleSelectSale}
                  placeholder="Search by customer name or amount..."
                />
              </div>

              {/* Select Medicine */}
              <div>
                <label className="block text-[11px] font-semibold tracking-[0.7px] uppercase text-[#4a6080] mb-1.5">
                  Medicine to Return
                </label>
                <AutoComplete
                  ref={medicineRef}
                  styles={selectStyles}
                  options={medicinesOptions}
                  onChange={(v) => handleSelectMedicine(v.value)}
                  placeholder={
                    selectedSale
                      ? "Search medicines from selected sale..."
                      : "Select a sale first..."
                  }
                  isDisabled={!selectedSale}
                />
                {!selectedSale && (
                  <p className="text-[11px] text-[#b0bcc9] mt-1.5 ml-1">
                    ↑ Select an original sale to load its medicines
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* ── Return Items Table ── */}
          <div className="bg-white rounded-2xl shadow-sm border border-[#eef1f6] overflow-hidden mb-6">
            <div className="px-6 py-4 border-b border-[#eef1f6] flex items-center justify-between">
              <h2 className="text-[13px] font-semibold uppercase tracking-[0.8px] text-[#4a6080]">
                Return Items
              </h2>
              {products.length > 0 && (
                <span className="text-[11px] font-semibold bg-blue-50 text-primary border border-blue-100 px-2.5 py-1 rounded-full">
                  {products.length} item{products.length !== 1 ? "s" : ""}
                </span>
              )}
            </div>

            <div className="overflow-x-auto hidden lg:block">
              <table className="w-full text-left">
                <thead>
                  <tr style={{ background: '#00A95B' }}>
                    {[
                      "Sr.No",
                      "Item Code",
                      "Item Name",
                      "Batch No.",
                      "Box",
                      "Pack",
                      "Units",
                      "Expiry",
                      "Sale Price/Unit",
                      "Discount",
                      "Discounted Amt",
                      "Total Amt",
                      "",
                    ].map((h) => (
                      <th
                        key={h}
                        className="px-3 py-3.5 text-[11px] font-semibold uppercase tracking-[0.6px] text-white whitespace-nowrap"
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {products.length > 0 ? (
                    products.map((product, index) => (
                      <tr
                        key={index}
                        className={`text-[13px] border-b border-[#f0f4f8] transition-colors ${
                          index % 2 === 0 ? "bg-white" : "bg-[#fafbfd]"
                        } hover:bg-blue-50`}
                      >
                        <td className="px-3 py-3 font-bold text-blue-500">{index + 1}</td>
                        <td className="px-3 py-3 font-medium text-[#4a6080]">{product.itemCode}</td>
                        <td className="px-3 py-3 font-semibold text-[#0a2540] whitespace-nowrap">
                          {product.itemName}
                        </td>
                        <td className="px-3 py-3 font-medium text-[#4a6080]">{product.batch_no}</td>
                        <td className="px-3 py-3 font-medium text-[#4a6080]">{product.box}</td>
                        <td className="px-3 py-3 font-medium text-[#4a6080]">{product.pack}</td>

                        {/* Units */}
                        {/* <td className="px-3 py-3">
                          <input
                            value={product.quantity}
                            type="number"
                            name="quantity"
                            className="cell-input"
                            onChange={(e) =>
                              handleQuantity(index, e.target.name, e.target.value)
                            }
                          />
                        </td> */}
 <td className="px-3 py-3">
<input
  value={product.quantity}
  type="number"
  name="quantity"
  min={1}
  max={product.original_quantity}
  className="cell-input"
  onChange={(e) =>
    handleQuantity(index, e.target.name, e.target.value)
  }
/>
</td>
                        {/* Expiry */}
                        <td className="px-3 py-3 font-medium text-[#4a6080]">
                          {/* <input
                            value={product.expiry_date}
                            type="date"
                            name="expiry_date"
                            className="cell-input"
                            style={{
                              width: "110px",
                              borderColor: !product.expiry_date ? "#f87171" : undefined,
                              background: !product.expiry_date ? "#fff5f5" : undefined,
                            }}
                            onChange={(e) =>
                              handleQuantity(index, "expiry_date", e.target.value)
                            }
                          /> */}
                          {product.expiry_date}
                        </td>

                        {/* Sale Price */}
                        <td className="px-3 py-3 font-bold text-[#0a2540]">
                          {product.sale_price}
                        </td>

                        {/* Discount */}
                        <td className="px-3 py-3 font-bold text-[#0a2540]">
                          {(product.sale_price - product.discount).toFixed(2)}
                        </td>

                        {/* Discounted Amount */}
                        <td className="px-3 py-3 font-bold text-primary whitespace-nowrap">
                          Rs. {Number(product.discount_price || 0).toFixed(2)}
                        </td>

                        {/* Total */}
                        <td className="px-3 py-3 font-bold text-[#0a2540] whitespace-nowrap">
                          Rs. {Number(product.total_price || 0).toFixed(2)}
                        </td>

                        {/* Delete */}
                        <td className="px-3 py-3">
                          <button
                            type="button"
                            onClick={() => handleRemovePurchase(index)}
                            className="w-7 h-7 flex items-center justify-center rounded-lg bg-red-50 text-red-400 hover:bg-red-100 hover:text-red-600 transition-colors"
                          >
                            <MdDelete size={15} />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="13" className="text-center py-12 text-[#b0bcc9]">
                        <div className="flex flex-col items-center gap-2">
                          <MdLocalPharmacy size={32} className="text-[#dde4ed]" />
                          <span className="text-sm">
                            No medicines added yet. Select a sale and choose medicines to return.
                          </span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="block md:hidden p-4 space-y-4">
  {products.length > 0 ? (
    products.map((product, index) => (
      <div
        key={index}
        className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4"
      >
        {/* Header */}
        <div className="flex justify-between items-start">
          <div>
            <h3 className="font-bold text-[#0a2540] text-base">
              {product.itemName}
            </h3>

            <p className="text-xs text-gray-500">
              Code : {product.itemCode}
            </p>

            <p className="text-xs text-gray-500">
              Batch : {product.batch_no}
            </p>
          </div>

          <button
            onClick={() => handleRemovePurchase(index)}
            className="w-8 h-8 rounded-lg bg-red-50 text-red-500 flex items-center justify-center"
          >
            <MdDelete />
          </button>
        </div>

        <div className="grid grid-cols-2 gap-3 mt-4 text-sm">

          <div>
            <p className="text-gray-500">Box</p>
            <span className="font-semibold">
              {product.box}
            </span>
          </div>

          <div>
            <p className="text-gray-500">Pack</p>
            <span className="font-semibold">
              {product.pack}
            </span>
          </div>

          <div>
            <p className="text-gray-500">Expiry</p>
            <span className="font-semibold">
              {product.expiry_date}
            </span>
          </div>

          <div>
            <p className="text-gray-500">Quantity</p>

            <input
              value={product.quantity}
              type="number"
              name="quantity"
              min={1}
              max={product.original_quantity}
              className="cell-input mt-1 w-full"
              onChange={(e) =>
                handleQuantity(
                  index,
                  e.target.name,
                  e.target.value
                )
              }
            />
          </div>

          <div>
            <p className="text-gray-500">Sale Price</p>
            <span className="font-semibold">
              Rs. {product.sale_price}
            </span>
          </div>

          <div>
            <p className="text-gray-500">Discount</p>
            <span className="font-semibold text-orange-600">
              Rs. {(product.sale_price - product.discount).toFixed(2)}
            </span>
          </div>

          <div>
            <p className="text-gray-500">Discounted Amount</p>
            <span className="font-semibold text-green-600">
              Rs. {Number(product.discount_price || 0).toFixed(2)}
            </span>
          </div>

          <div>
            <p className="text-gray-500">Total Amount</p>
            <span className="font-bold text-[#00A95B]">
              Rs. {Number(product.total_price || 0).toFixed(2)}
            </span>
          </div>

        </div>
      </div>
    ))
  ) : (
    <div className="text-center py-10 text-gray-400">
      No medicines added yet.
    </div>
  )}
</div>
          </div>

          {/* ── Summary + Submit ── */}
          <div className="bg-white rounded-2xl shadow-sm border border-[#eef1f6] p-6">
            <h2 className="text-[13px] font-semibold uppercase tracking-[0.8px] text-[#4a6080] mb-5">
              Return Summary
            </h2>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
              <SummaryCard
                label="Total Medicines"
                value={products.length}
                color="#0a2540"
                bg="#f4f7fb"
                border="border-[#eef1f6]"
              />
              <SummaryCard
                label="Total Amount"
                value={`Rs. ${totalAmount.toFixed(2)}`}
                color="#0a2540"
                bg="#f4f7fb"
                border="border-[#eef1f6]"
              />
              <SummaryCard
                label="Total Discount"
                value={`Rs. ${totalDiscount.toFixed(2)}`}
                color="#f59e0b"
                bg="#fffbeb"
                border="border-amber-100"
              />
              <SummaryCard
                label="Discounted Amount"
                value={`Rs. ${totalDiscounted.toFixed(2)}`}
                color="#00A95B"
                bg="#eff6ff"
                border="border-blue-100"
              />
            </div>

            <div className="flex justify-end">
              <button
                type="button"
                onClick={handleSubmit}
                disabled={loading}
                className="flex items-center gap-2.5 px-8 py-3.5 rounded-xl text-white text-[15px] font-semibold tracking-[0.3px] transition-all disabled:opacity-60 disabled:cursor-not-allowed hover:enabled:-translate-y-px"
                style={{
                  background: "linear-gradient(135deg, #00A95B 40%, #007a40 100%)",
                  boxShadow: "0 4px 20px rgba(0,169,91,0.35)",
                  fontFamily: "'DM Sans', sans-serif",
                }}
              >
                {loading ? (
                  <>
                    <AiOutlineLoading3Quarters size={17} className="animate-spin" />
                    Generating…
                  </>
                ) : (
                  <>
                    <MdArrowForward size={18} />
                    Generate Sale Return
                  </>
                )}
              </button>
            </div>
          </div>

        </div>
      </div>

      <AddPurchaseModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSave={(p) => { setProducts([...products, p]); setIsOpen(false); }}
      />

      <InvoiceSaleModal open={open} onClose={() => setOpen(false)} />
    </>
  );
};

/* ── Summary Card ── */
const SummaryCard = ({ label, value, color, bg, border }) => (
  <div
    className={`rounded-xl p-4 flex flex-col gap-1 border ${border}`}
    style={{ background: bg }}
  >
    <span className="text-[11px] font-semibold uppercase tracking-[0.7px] text-[#8a9bb0]">
      {label}
    </span>
    <span
      className="text-[18px] font-bold"
      style={{ color, fontFamily: "'DM Serif Display', serif" }}
    >
      {value}
    </span>
  </div>
);

export default RecordSalesReturn;